export const ApiUrls = {
    getAllCharts: '/api/affiliates/v1/sales/',
    postSearchPolicies: '/dashboard/search-policies/',
    postSalesReport: '/dashboard/sales-report/',
    postSalesReportExcel: '/dashboard/sales-report/excel/',
    postSalesReportPdf: '/dashboard/sales-report/pdf/',
    postProductionReport: '/dashboard/production-report/',
    postClickReport: '/dashboard/click-report/',
    postProductionReportExcel: '/dashboard/production-report/excel/',
    postProductionReportPdf: '/dashboard/production-report/pdf/',
    postClickReportExcel: '/dashboard/click-report/excel/',
    postClickReportPdf: '/dashboard/click-report/pdf/',
    postLoginHistory: '/dashboard/login-history/',
    getPolicyMaximum: '/dashboard/policy-maximum/?displaySection=',
    postEarningsReport: '/dashboard/travel-payout-report/',
    postEarningsReportExcel: '/dashboard/travel-payout-report/excel/',
    postReceivableReportExcel: '/dashboard/revenue-report/excel/',
    postReceivableDataReportExcel: '/dashboard/revenue-data-report/excel/',
    postPremiumAffiliateReportExcel: '/dashboard/premium-by-affiliate-report/excel/',
    postPremiumAffiliate: '/dashboard/premium-by-affiliate-report/',
    searchApplications: '/dashboard/pending-applications/',
    postDomesticBusReport: '/dashboard/domestic-business-report/',
    postDomesticBusReportExcel: '/dashboard/domestic-business-report/excel/',
    postDomesticBusTransactionReportExcel: '/dashboard/domestic-business-transactions/excel/',
}

export const SessionKeys = {
    searchPolicyFields: 'searchPolicyFields',
    salesReportFields: 'salesReportFields',
    productionReportFields: 'productionReportFields',
    activityReportFields: 'activityReport',
    clickReportFields: 'clickReport',
    loaderVersion: 'loaderVersion',
    lang: 'lang',
    earningsReportFields: 'earningsReportFields',
    premiumAffiReportFields: 'premiumAffiReportFields',
    searchApplicationFields: 'searchApplicationFields'
}